import { HeroSection } from '../components/HeroSection';
import { WhatYouCanRentSection } from '../components/WhatYouCanRentSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { WhereWeAreSection } from '../components/WhereWeAreSection';
import { MonthlyRentalHighlightSection } from '../components/MonthlyRentalHighlightSection';
import { RecentOrderPrompt } from '@/features/orders/components/RecentOrderPrompt';

export const Home = () => {
    return (
        <>
            {/* SEO metadata lives in the route shell's `meta` export
                (`app/routes/$locale._index.tsx`). */}

            {/* Gentle return path for guests with a recently saved order (this device) */}
            <RecentOrderPrompt />

            {/* Hero: what we rent and where, photo, search */}
            <HeroSection />

            {/* Real products from the catalogue */}
            <WhatYouCanRentSection />

            {/* Booking steps + the two rental types */}
            <HowItWorksSection />

            {/* Every pickup location, linking into its catalogue */}
            <WhereWeAreSection />

            {/* Monthly Rental Highlight: dark teal CTA section */}
            <MonthlyRentalHighlightSection />
        </>
    );
};
